import { render, staticRenderFns } from "./SalesNew.vue?vue&type=template&id=2b88375c&"
import script from "./SalesNew.vue?vue&type=script&lang=js&"
export * from "./SalesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports